//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavHomeFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21 10.35L23 11.5V9.19998L21 8.03998L20.93 7.99998H21V4.99998H19V6.87998L12 2.84998L1 9.19998V11.5L3 10.35V21H21V10.35Z" fill="currentColor" /></svg>;
}
export default IconNavHomeFill;